module.exports = __webpack_public_path__ + "img/AK.423c9713.png";